export default __webpack_public_path__ + "static/media/offer-covid.305243df.jpg";